import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import claimAdjudicationApi from '../../../api/services/ClaimInbox/COB/claimAdjudication.service';
import claimServicesAPI from '../../../api/services/MergeClaims/claimServices.service';

const initialState = {
  claimAdjudication: [],
  groupCode: [],
  reasonCode: [],
  serviceLine: [],
  errorCount: [],
  claimErrorCount: 0,
  serviceErrorCount: 0,
  viewOnly: false,
  loading: false,
};

interface MyData {
  id: string | undefined;
  type: any;
  parentClaimId: any;
}
interface Data {
  claimId: any;
}
export const getBillingLineCall = createAsyncThunk(
  'getBillingLineCall',
  async (payload: Data, { rejectWithValue }) => {
    try {
      const res = await claimServicesAPI.getClaimServicesById(payload);
      return res?.data?.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const getCOBErrorCountCall = createAsyncThunk(
  'getCOBErrorCountCall',
  async (payload: Data, { rejectWithValue }) => {
    try {
      const res = await claimAdjudicationApi.getErrorCount(payload);
      return res?.data?.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const getClaimAndServiceLineCall = createAsyncThunk(
  'getClaimAndServiceLineCall',
  async (payload: MyData, { rejectWithValue }) => {
    try {
      const res = await claimAdjudicationApi.getClaimAndServiceLine(payload);
      return res?.data?.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const getGroupCodeCall = createAsyncThunk(
  'getGroupCodeCall',
  async (_, { rejectWithValue }) => {
    try {
      const res = await claimAdjudicationApi.getgroupCode();
      return res?.data?.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const getReasonCodeCall = createAsyncThunk(
  'getReasonCodeCall',
  async (_, { rejectWithValue }) => {
    try {
      const res = await claimAdjudicationApi.getResonCode();
      return res?.data?.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);

const claimAdjudication = createSlice({
  name: 'claimAdjudication',
  initialState,
  reducers: {
    setClaimErrorConunt: (state, action) => {
      state.claimErrorCount = action.payload;
    },
    setServiceErrorCOunt: (state, action) => {
      state.serviceErrorCount = action.payload;
    },
    clearServiceLine: state => {
      state.serviceLine = [];
    },
    clearingAdjudicationData: state => {
      state.claimAdjudication = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getClaimAndServiceLineCall.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(getClaimAndServiceLineCall.fulfilled, (state: any, action) => {
        state.claimAdjudication = action.payload;
        state.loading = false;
      })
      .addCase(getCOBErrorCountCall.fulfilled, (state: any, action) => {
        state.errorCount = action.payload;
        state.loading = false;
      })
      .addCase(getBillingLineCall.fulfilled, (state: any, action) => {
        state.serviceLine = action.payload;
        state.loading = false;
      })
      .addCase(getGroupCodeCall.fulfilled, (state: any, action) => {
        state.groupCode = action.payload;
        state.loading = false;
      })
      .addCase(getReasonCodeCall.fulfilled, (state: any, action) => {
        state.reasonCode = action.payload;
        state.loading = false;
      })
      .addCase(getClaimAndServiceLineCall.rejected, (state: any) => {
        state.loading = true;
      });
  },
});

// Action creators are generated for each case reducer function
export const {
  clearServiceLine,
  setClaimErrorConunt,
  setServiceErrorCOunt,
  clearingAdjudicationData,
} = claimAdjudication.actions;

export default claimAdjudication.reducer;
